"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockValueEventProducer = void 0;
const ListenerCollection_1 = require("./ListenerCollection");
class MockValueEventProducer {
    constructor() {
        this.listenerCollection = new ListenerCollection_1.ListenerCollection();
    }
    emitValueEvent(status, error, value) {
        this.listenerCollection.invoke(status, error, value);
    }
    registerValueEventListener(listener) {
        return this.listenerCollection.add(listener);
    }
}
exports.MockValueEventProducer = MockValueEventProducer;
//# sourceMappingURL=MockValueEventProducer.js.map